import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const pipelineContent = EntityContentBlueprint.make({
  name: 'pipelines',
  params: {
    path: '/pipelines',
    title: 'Pipelines',
    loader: async () => {
      const { PipelineView } = await import('./components/PipelineView');
      return <PipelineView />;
    },
  },
});

export const awsCodepipelinePlugin = createFrontendPlugin({
  pluginId: 'aws-codepipeline',
  extensions: [pipelineContent],
});
